import { useState } from "react";
import SearchBlock from "./searchBlock";
import AuditCard from "./AuditCard";
import { Col, Row } from "react-bootstrap";

const AuditBlockInterface =({facilityData, data}) =>{
    const [auditData,setAuditData]=useState(data);
    if (facilityData.length===0){
        return(<p>Создайте в системе хотя бы одно предприятие.</p>)
    }
    if(data.length===0){
        return(<p>Нет аудитов.</p>)
    }

    const handleFiltersData = (facility, status, type, name) => {
        const result_filter=data.filter(item => {
            if (name!==null && item.id!==name) return false;
            if (facility!==null && item.facility!==facility) return false;
            if (status!==null && item.is_active!==status) return false;
            if (type!==null && item.audit_type!==type) return false;
            return true;
        })
        setAuditData(result_filter)
    }

    const facilityOptions=facilityData.map((elem)=>{return {label:elem.short_name, value:elem.short_name}})
    const auditOptions=data.map((elem)=>{return {label:elem.name, value:elem.id}})

    return(<>
        <div>
            <SearchBlock 
            facilityOptions={facilityOptions} 
            auditOptions={auditOptions} 
            handleFiltersData={handleFiltersData}/>
        </div>
        <div>
            {/* {auditData.map((elem)=>(<p>{JSON.stringify(elem)}</p>))} */}
            {auditData.length==0 ? 
            <p>Нет данных по текущим фильтрам.</p> : 
            <><Row>
            {auditData.map((elem)=>(<Col md={4}><AuditCard key={elem.id} audit={elem}/></Col>))}</Row>
            </>}
        </div>
    </>)
}

export default AuditBlockInterface;